<template>
  <main class="payment">
    <header class="form-header">
      <h2 class="form-header__title">Olá, {{ name }}!</h2>
      <h3 class="form-header__subtitle">
        Preencha os dados abaixo para concluir o pagamento da sua assinatura
      </h3>
    </header>
    <section class="wrapper section">
      <FormSubscription @submit="submit" :name="name"></FormSubscription>
    </section>

    <ProcessPayment v-show="loading" />
  </main>
</template>

<script>
import FormSubscription from '@/components/forms/FormSubscription.vue';
import subscriptionPayment from '@/services/subscription-payment';
import ProcessPayment from '@/components/modals/ProcessPayment.vue';
import getToken from '@/services/iugu';
import { transformToArray } from '../../utils/error';

export default {
  name: 'Subscription',
  components: {
    FormSubscription,
    ProcessPayment
  },
  data() {
    return {
      name: sessionStorage.name,
      loading: false
    };
  },
  methods: {
    async submit(items) {
      try {
        this.$root.$emit('button-loading', true);
        this.loading = true;

        const token = await getToken(items);

        await subscriptionPayment(this.$route.params.hash, {
          name: items.name,
          cpf: items.cpf,
          additionals: items.additionals,
          token
        });

        sessionStorage.setItem('subscription_success', true);
        this.$router.push({ name: 'subscription-success' });
      } catch (err) {
        this.$root.$emit('subscription-error', true);

        if (err.response) {
          if (err.response.status === 422) {
            const errors = transformToArray(err);

            this.$root.$emit('form-error', errors);

            if (errors.length) {
              this.$toaster.error(errors[0].value);
            }
          } else {
            this.$toaster.error(err.response.data.error.message);
          }
        } else {
          this.$toaster.error(err.message);
        }
      } finally {
        this.loading = false;
        this.$root.$emit('button-loading', false);
      }
    }
  }
};
</script>
